import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import EmptyTd from "./EmptyTd";

const Row = styled.tr`
  & > td {
    font-size: 10pt !important;
    padding: 3px !important;
    padding-left: 7px !important;
  }
  &:hover > td {
    background-color: #fafafa;
  }
`;

const EmptySelectableId = styled(EmptyTd)`
  ${(props) =>
    props.selected &&
    css`
      background-color: #e8ffd4 !important;
    `};
`;

const SelectableTd = styled.td`
  ${(props) =>
    props.selected &&
    css`
      background-color: #e8ffd4 !important;
    `};
`;

export default class ScheduleRow extends React.Component {
  render() {
    const {
      product,
      isProductSelected,
      schedule,
      showProduct,
      addNewSchedule,
      selectProduct,
      isScheduleSelected,
      selectSchedule,
    } = this.props;
    return (
      <Row>
        {showProduct ? (
          <Fragment>
            <SelectableTd selected={isProductSelected}>
              <input type="checkbox" checked={isProductSelected} onChange={selectProduct} />
            </SelectableTd>
            <SelectableTd selected={isProductSelected}>
              <a href={"/products/products/" + product.id + "/show"}>
                {product.name}
                {product.default_product_field_values &&
                  product.default_product_field_values.length > 0 &&
                  product.default_product_field_values.map((dv) => (
                    <span class="badge badge-info pull-right">
                      {dv.client_list_name}: {dv.default_value}
                    </span>
                  ))}
              </a>
            </SelectableTd>
          </Fragment>
        ) : (
          <EmptySelectableId selected={isProductSelected} colSpan={2} />
        )}

        {schedule ? (
          <Fragment>
            <SelectableTd selected={isScheduleSelected}>
              {schedule.sample_information_name}
            </SelectableTd>
            <SelectableTd selected={isScheduleSelected}>
              {schedule.client_suite_name}
            </SelectableTd>
            <SelectableTd selected={isScheduleSelected}>
              {schedule.client_specification_name}
            </SelectableTd>
            <SelectableTd selected={isScheduleSelected}>
              <input type="checkbox" checked={isScheduleSelected} onChange={selectSchedule} />
            </SelectableTd>
            {!showProduct && <EmptyTd />}
          </Fragment>
        ) : (
          <Fragment>
            <td colSpan={4} />
          </Fragment>
        )}
        {showProduct && (
          <td>
            {/* <i className="fa fa-refresh" onClick={() => reloadProduct(product.id)} /> */}
            <i className="fa fa-plus" onClick={addNewSchedule} />
          </td>
        )}
      </Row>
    );
  }
}

ScheduleRow.propTypes = {
  showProduct: PropTypes.bool,
  product: PropTypes.object,
  schedule: PropTypes.any,
  reloadProduct: PropTypes.func,
  isProductSelected: PropTypes.bool,
  isScheduleSelected: PropTypes.bool,
  selectProduct: PropTypes.func,
  selectSchedule: PropTypes.func,
};
